import { Button, Container, Grid, Paper, Radio, Stack, Typography } from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const GstReport = () => {
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset ,control } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("HELLLLLLO USERSSSS", user)
  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto',
        maxWidth: '100vw',
        minHeight: '100vh'
      }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                GST Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3}}>
                {/* Date Inputs */}
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 1 }} name="from_date" type="date" />
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 1 }} name="to_date" type="date" />
                </Stack>

                {/* Radio Buttons for Report Types */}
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Report Type</Typography>
                <Controller
                  name="report"
                  control={control}
                  render={({ field }) => (
                    <Stack direction="row" flexWrap="wrap" spacing={2}>
                      {[
                        { value: 'gst_purchase_register', label: 'GST Purchase Register' },
                        { value: 'gst_sale_register', label: 'GST Sale Register' },
                        { value: 'gst_item_wise_purchase_register', label: 'GST Item Wise Purchase Register' },
                        { value: 'gst_item_wise_sale_register', label: 'GST Item Wise Sale Register' },
                        { value: 'gst_per_sale_summary_register', label: 'GST Per Sale Summary Register' },
                        { value: 'gst_per_purchase_summary_register', label: 'GST Per Purchase Summary Register' },
                        { value: 'gst_retail_sale_register', label: 'GST Retail Sale Register' },
                        { value: 'gst_retail_sale_register_percent', label: 'GST Retail Sale Register %' },
                        { value: 'gst_retail_sale_return_register', label: 'GST Retail Sale Return Register' },
                        { value: 'gst_retail_sale_return_register_percent', label: 'GST Retail Sale Return Register %' }
                      ].map((option) => (
                        <label key={option.value} style={{ flex: '1 0 45%', display: 'flex', alignItems: 'center' }}>
                          <Radio
                            {...field}
                            value={option.value}
                            checked={field.value === option.value}
                          />
                          <Typography sx={{ ml: 1 ,fontWeight : 700,fontSize:"13px"}}>{option.label}</Typography>
                        </label>
                      ))}
                    </Stack>
                  )}
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
